import React from "react";

function Icon(props) {
    return <div >
        <img className="icon" src={props.imageUrl} alt={props.title}/>
    </div>
}

export default Icon;